import urbaniceLogo from '../../src/image/logo_urbanice_white.png'

export default {
	apiUrl: 'http://yoursite.com/api/',
};

const siteConfig = {
	siteName: 'Urbanice-Admin',
	siteIcon: urbaniceLogo,
	footerText: 'Urbanice-Admin ©2019-2024 Created by Urbanice.app',
	version: '3.6.9-6',
	DEBUG: false, //false, true
	VMS_STAGE: 'vms', //'prod':'vms','dev':'vms-dev'
	PATROL_STAGE: 'patrol', //'prod':'patrol','dev':'patrol-dev'
	INCIDENT_STAGE: 'incident-report', //'prod':'incident-report','dev':'incident-report-dev'
};

const themeConfig = {
	topbar: 'themedefault',
	sidebar: 'themedefault',
	layout: 'themedefault',
	theme: 'themedefault',
};

const language = 'english';


const jwtConfig = {
	fetchUrl: '/api/',
	secretKey: 'secretKey',
};


const Auth0Config = {
	domain: '',
	clientID: '',
	allowedConnections: ['Username-Password-Authentication'],
	rememberLastLogin: true,
	language: 'en',
	closable: true,
	options: {
		auth: {
			autoParseHash: true,
			redirect: true,
			redirectUrl: 'http://localhost:3000/auth0loginCallback'
		},
		languageDictionary: {
			title: 'Urbanice-Admin',
			emailInputPlaceholder: '',
			passwordInputPlaceholder: ''
		},
		theme: {
			labeledSubmitButton: true,
			logo: '',
			primaryColor: '#E14615',
			authButtons: {
				connectionName: {
					displayName: 'Log In',
					primaryColor: '#b7b7b7',
					foregroundColor: '#000000'
				}
			}
		}
	}
};

const firebaseConfig = {
	authDomain: 'urbaniceapp.firebaseapp.com',
	databaseURL: 'https://urbaniceapp.firebaseio.com',
	projectId: 'urbaniceapp',
	storageBucket: 'urbaniceapp.appspot.com',
	messagingSenderId: '548898390077'
};

export { siteConfig, language, themeConfig, jwtConfig,Auth0Config,firebaseConfig };
